import { Link } from 'react-router-dom';
import { DocsLayout } from '../components/DocsLayout';

export function GettingStartedPage() {
  return (
    <DocsLayout
      title="Quickstart"
      updated="August 26, 2026"
      summary="From signup to first run and Quality HQ. AI authoring is optional — execution and Quality Intelligence do not require an LLM."
    >
      <h2>1. Create an account</h2>
      <p>
        Head to <Link to="/register">rynora.app/register</Link> and sign up with an email and password. Confirm the
        verification email, then sign in.
      </p>

      <h2>2. Create a project</h2>
      <p>
        From the Dashboard, create a project. Open the app to the visual flow builder when you are ready to author an
        automation.
      </p>

      <h2>3. Build and publish a flow</h2>
      <p>You have two options:</p>
      <ul>
        <li>
          <strong>Drag &amp; drop:</strong> add steps (Navigate, Click, Type, Assert) on the canvas.
        </li>
        <li>
          <strong>Natural language (optional AI):</strong> describe the journey; review the generated steps before
          publish. Locators may still exist under the hood — healing and maintenance stay human-approved.
        </li>
      </ul>
      <p>Publish the flow so it can execute and (later) export as a Playwright project.</p>

      <h2>4. Run it</h2>
      <p>
        Launch a run against SaaS headless (or a private execution agent if configured). Open the run to inspect steps
        and screenshots.
      </p>

      <h2>5. Open Quality Intelligence</h2>
      <p>
        In the project, open <strong>Quality HQ</strong> for Failure Intelligence and advisory Release Confidence. When
        you are ready for change-aware QE, connect GitLab or Bitbucket (Usage → integrations), bind a source repo, and
        compare a commit SHA — see in-app Help for Change Impact and TIA.
      </p>

      <h2>6. Evidence and export</h2>
      <p>
        Export a portable quality evidence bundle when you need an audit artifact. From a published flow, use{' '}
        <strong>Export Playwright</strong> for a TypeScript project ZIP — without claiming Rynora runtime parity.
      </p>

      <h2>Next</h2>
      <ul>
        <li>
          <Link to="/docs">Documentation overview</Link>
        </li>
        <li>
          <Link to="/docs/api">API reference</Link>
        </li>
        <li>
          <Link to="/trust">Trust Center</Link>
        </li>
      </ul>
    </DocsLayout>
  );
}
